import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { APPLICATION_URL } from '../../constants';
import { Container } from '../common/base';

function ImageAndContent({ buttonUrl }) {
    const { banner } = useStaticQuery(graphql`
        {
            banner: contentfulSiteImages(name: { eq: "ApplyNowImage" }) {
                name
                imageFile {
                    localFile {
                        childImageSharp {
                            fluid(
                                maxWidth: 1920
                                quality: 100
                                srcSetBreakpoints: [400, 600, 960, 1280, 1920]
                                toFormat: WEBP
                            ) {
                                ...GatsbyImageSharpFluid
                                ...GatsbyImageSharpFluidLimitPresentationSize
                            }
                            gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH, formats: WEBP)
                        }
                    }
                }
            }
        }
    `);

    return (
        <section className='bg-avenue-parchment-500'>
            <Container>
                <div className='flex flex-col items-center md:flex-row'>
                    <GatsbyImage
                        loading='lazy'
                        image={banner?.imageFile?.localFile?.childImageSharp?.gatsbyImageData}
                        alt='Woman with Mug'
                        className='w-full object-cover md:w-1/2'
                    />

                    <div className='flex flex-col justify-center space-y-10 py-8 md:px-10 lg:px-16'>
                        <h2 className='text-4xl !leading-tight text-avenue-slate-500 lg:text-5xl'>
                            A better way <br />
                            is a click away
                        </h2>

                        <a
                            id='apply-now-btn'
                            href={buttonUrl || APPLICATION_URL}
                            type='button'
                            className='w-max whitespace-nowrap rounded-md bg-avenue-orange-500 px-8 py-4 text-lg font-bold tracking-normal text-white shadow-lg transition delay-150 duration-300 ease-in-out hover:-translate-y-1 hover:scale-110'
                            aria-label='Apply now'
                            target='_self'
                            rel='noreferrer'
                        >
                            Apply Now
                            <span className='tracking-normal text-white'> →</span>
                        </a>
                    </div>
                </div>
            </Container>
        </section>
    );
}

export default ImageAndContent;
